"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _marginSelectors = require("./marginSelectors");
Object.keys(_marginSelectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _marginSelectors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _marginSelectors[key];
    }
  });
});
var _marginHistorySelectors = require("./marginHistorySelectors");
Object.keys(_marginHistorySelectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _marginHistorySelectors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _marginHistorySelectors[key];
    }
  });
});
var _marginProductSelectors = require("./marginProductSelectors");
Object.keys(_marginProductSelectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _marginProductSelectors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _marginProductSelectors[key];
    }
  });
});
var _marginOrderSelectors = require("./marginOrderSelectors");
Object.keys(_marginOrderSelectors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _marginOrderSelectors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _marginOrderSelectors[key];
    }
  });
});